//created by dubinbin 2018.7.10

import React from 'react'
import {connect} from 'react-redux'
import { TimeStream } from '../../utils';
import '../../css/page/ChannelPageMiddleTab.css'

class ChannelPageMiddleTab extends React.Component{
    constructor() {
        super()
        this.state= {
            content:[]
        }
    }

    render() {
        const {data} = this.props;
        let recentStudy = null;
        let starting = null;
        data.map(v=>{
            if(v.type=='recent'){
                recentStudy = v
            }else{
                starting = v
            }
        })
        return data.length!==0 ? (
            <div className="ChannelPageMiddleTab">
                {recentStudy!==null ?
                    <div className="ChannelPageMiddleTab_main" onClick={()=> { window.location = this.props.frAccess && recentStudy.lecture_mode === 'default'  ? `/classroom/${recentStudy.id}` : `/lecture/${recentStudy.id}`}}>
                        <div className="ChannelPageMiddleTab_left">
                            <img className="tag" src={require(`../../images/channel/recently_Study@3x.png`)} alt=""/>
                        </div>
                        <div className="ChannelPageMiddleTab_right">
                            <div className="ChannelPageMiddleTab_title">
                                {recentStudy.name}
                            </div>
                            <div className="ChannelPageMiddleTab_rightPoint">
                                {Math.round(recentStudy.learning_rate)}%
                            </div>
                        </div>
                        <div className="ChannelPageMiddleTab_right_bottom noLastChild">
                            {recentStudy.lecture_mode=='default' ? <div>{TimeStream(recentStudy.start_timestamp, 'YMD')}</div> : <div>{recentStudy.audio_length}分钟</div>}
                        </div>
                    </div>
                    :null}

                {starting!==null?
                    <div className="ChannelPageMiddleTab_main" onClick={()=> { window.location = this.props.frAccess && starting.lecture_mode === 'default' ? `/classroom/${starting.id}` : `/lecture/${starting.id}`}}>
                        <div className="ChannelPageMiddleTab_left">
                            <img className="tag" src={require(`../../images/channel/readyToStart@3x.png`)} alt=""/>
                        </div>
                        <div className="ChannelPageMiddleTab_right">
                            <div className="ChannelPageMiddleTab_title" style={{ width: "99.33%"}}>
                                {starting.name}
                            </div>
                            <div className="ChannelPageMiddleTab_rightPoint"></div>
                        </div>
                        <div className="ChannelPageMiddleTab_right_bottom">
                            {starting.lecture_mode =='default' ?  <div> {TimeStream(starting.start_timestamp, 'YMD')}</div> : <div>{starting.audio_length}分钟</div> }
                        </div>
                    </div>
                    :null }
            </div>
        ):null

    }

}

export default connect(state => ({
    frAccess: state.channel.frAccess
}))(ChannelPageMiddleTab)



// WEBPACK FOOTER //
// ./src/pages/channel/ChannelPageMiddleTab.js